import EmptyMessage from '@/components/EmptyMessage/EmptyMessage';

export default EmptyMessage;
